import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { stringToPointNumber } from "MainPages/Utils/decimal.utils";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const DieselUsageModal = ({
  mode = "I",
  onSubmit,
  show = false,
  handleClose,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();

  const handleModalSubmit = (e) => {
    e.stopPropagation(); 
  };

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Diesel Usage" : "Edit Diesel Usage"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {/* <form onSubmit={handleSubmit(onSubmit)} className="needs-validation"> */}
         <form
          onSubmit={(e) => {
            handleModalSubmit(e);
            handleSubmit(onSubmit)(e);
          }}
          className="needs-validation"
        >
          <div className="mb-3">
            <Input
              name="invoiceNumber"
              label="Invoice Number"
              placeholder="Enter Invoice Number"
              type="text"
              className={`form-control ${
                errors.invoiceNumber ? "is-invalid" : ""
              }`}
              required
              requiredMessage="Invoice Number is required"
              labelClassName="form-label"
            />
          </div>
          <div className="mb-3">
            <Input
              name="invoiceDate"
              label="Invoice Date"
              placeholder="Enter Invoice Date"
              type="date"
              className={`form-control ${
                errors.invoiceDate ? "is-invalid" : ""
              }`}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              required
              requiredMessage="Invoice Date is required"
              labelClassName="form-label"
              defaultValue={
                dayjs(watch("confirmationDate"), "YYYY-MM-DD") || ""
              }
              dateFormat="YYYY-MM-DD"
            />
          </div>
          <div className="mb-3">
            <Input
              name="usageLitres"
              label="Usage Litres"
              placeholder="Enter Usage Litres"
              type="text"
              className={`form-control ${
                errors.usageLitres ? "is-invalid" : ""
              }`}
              required
              requiredMessage="Usage Litres is required"
              onChange={(e) => stringToPointNumber(e.target.value)}
              labelClassName="form-label"
            />
          </div>
          <div className="mb-3">
            <Input
              name="amountInclGST"
              label="amountInclGST"
              placeholder="Enter amountInclGST"
              type="text"
              className={`form-control ${
                errors.amountInclGST ? "is-invalid" : ""
              }`}
              required
              requiredMessage="amountInclGST is required"
              onChange={(e) => stringToPointNumber(e.target.value)}
              labelClassName="form-label"
            />
          </div>
          <div className="mb-3">
            <Input
              name="vehicleNumber"
              label="Vehicle Number"
              placeholder="Enter Vehicle Number"
              type="string"
              className={`form-control ${
                errors.vehicleNumber ? "is-invalid" : ""
              }`}
              required
              requiredMessage="Vehicle Number is required"
              labelClassName="form-label"
            />
          </div>
          <div className="mb-3">
            <Input
              name="isActive"
              type="commonSelect"
              placeholder="Status"
              className={`form-control ${errors.isActive ? "is-invalid" : ""}`}
              label="Status"
              labelClassName="form-label"
              optionData={boolStatus}
              required={true}
              requiredMessage="Status is required"
              onChange={(selectedOption) => {
                setValue("isActive", selectedOption);
                trigger("isActive");
              }}
              defaultValue={watch("isActive")}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
          </div>

          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

DieselUsageModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DieselUsageModal;
